import {
  DrugCostInfo,
  PrescriptionFrequency,
  DrugCostCoverageReason,
} from "../@types";

const drugCostInfo: DrugCostInfo = {
  costs: [
    {
      mail_order: false,
      npi: "123",
      drug_costs: [
        {
          ndc: "12345",
          quantity: 1,
          frequency: PrescriptionFrequency.DAYS_30,
          full_cost: 0.2215,
          deductible_cost: 0.2215,
          initial_cost: 0.2215,
          gap_cost: 0.2215,
          catastrophic_cost: 0.2215,
          covered: false,
          default_price_used: false,
          coverage_reason: DrugCostCoverageReason.COVERED,
        },
      ],
      estimated_monthly_costs: [
        {
          date: "2019-06-01",
          deductible: 0.22,
          initial: 0,
          gap: 0,
          catastrophic: 0,
          total: 0.22,
        },
        {
          date: "2019-07-01",
          deductible: 0.22,
          initial: 0,
          gap: 0,
          catastrophic: 0,
          total: 0.22,
        },
        {
          date: "2019-08-01",
          deductible: 0.22,
          initial: 0,
          gap: 0,
          catastrophic: 0,
          total: 0.22,
        },
        {
          date: "2019-09-01",
          deductible: 0.22,
          initial: 0,
          gap: 0,
          catastrophic: 0,
          total: 0.22,
        },
        {
          date: "2019-10-01",
          deductible: 0.22,
          initial: 0,
          gap: 0,
          catastrophic: 0,
          total: 0.22,
        },
        {
          date: "2019-11-01",
          deductible: 0.22,
          initial: 0,
          gap: 0,
          catastrophic: 0,
          total: 0.22,
        },
        {
          date: "2019-12-01",
          deductible: 0.22,
          initial: 0,
          gap: 0,
          catastrophic: 0,
          total: 0.22,
        },
      ],
      in_network: false,
      preferred: false,
      phase_information: {
        deductible_amount: 415,
        initial_coverage_start: "",
        gap_start: "",
        catastrophic_start: "",
      },
      estimated_yearly_total: 1.5400001,
    },
    {
      mail_order: true,
      npi: "",
      drug_costs: [
        {
          ndc: "23456",
          quantity: 3,
          frequency: PrescriptionFrequency.DAYS_90,
          full_cost: 0.7089,
          deductible_cost: 0.7089,
          initial_cost: 0.7089,
          gap_cost: 0.7089,
          catastrophic_cost: 0.7089,
          covered: true,
          default_price_used: false,
          coverage_reason: DrugCostCoverageReason.COVERED,
        },
      ],
      estimated_monthly_costs: [
        {
          date: "2019-06-01",
          deductible: 0.71,
          initial: 0,
          gap: 0,
          catastrophic: 0,
          total: 0.71,
        },
        {
          date: "2019-07-01",
          deductible: 0.71,
          initial: 0,
          gap: 0,
          catastrophic: 0,
          total: 0.71,
        },
        {
          date: "2019-08-01",
          deductible: 0.71,
          initial: 0,
          gap: 0,
          catastrophic: 0,
          total: 0.71,
        },
        {
          date: "2019-09-01",
          deductible: 0.71,
          initial: 0,
          gap: 0,
          catastrophic: 0,
          total: 0.71,
        },
        {
          date: "2019-10-01",
          deductible: 0.71,
          initial: 0,
          gap: 0,
          catastrophic: 0,
          total: 0.71,
        },
        {
          date: "2019-11-01",
          deductible: 0.71,
          initial: 0,
          gap: 0,
          catastrophic: 0,
          total: 0.71,
        },
        {
          date: "2019-12-01",
          deductible: 0.71,
          initial: 0,
          gap: 0,
          catastrophic: 0,
          total: 0.71,
        },
      ],
      in_network: false,
      preferred: false,
      phase_information: {
        deductible_amount: 415,
        initial_coverage_start: "",
        gap_start: "",
        catastrophic_start: "",
      },
      estimated_yearly_total: 4.97,
    },
  ],
  lowest_retail_total: 1.5400001,
  lowest_mail_total: 4.97,
  restrictions: [
    {
      ndc: "123",
      conditions: [""],
      opioid: false,
      home_infusion: false,
      free_first_fill: false,
      partial_gap: false,
      limited_distribution: false,
      vaccine: true,
    },
  ],
  plan: {
    contract_id: "H1660",
    contract_year: "2019",
    plan_id: "0",
    segment_id: "0",
  },
  excluded_drugs: [""],
};

export default drugCostInfo;
